window.bbs = window.bbs || {};

bbs.menu = (function () {
  "use strict";

  var timer = [];

  function init() {
    var elements = document.querySelectorAll('[data-bbs-module="menu"]');

    for (let i = 0, l = elements.length; i < l; i++) {
      handleMenu(elements[i]);
    }
  }

  function handleMenu(element) {
    var menuItems = element.querySelectorAll('[data-menu="item"]');

    for (let i = 0, l = menuItems.length; i < l; i++) {
      menuItems[i].addEventListener("mouseenter", function (event) {
        openMenu(event, menuItems, i);
      });

      menuItems[i].addEventListener("mouseleave", function (event) {
        closeMenu(event, menuItems, i, 350);
      });

      var link = menuItems[i].querySelector('[data-menu="link"]');

      link.addEventListener("touchstart", function (event) {
        toggleMenu(event, menuItems, i, 0);
      });
    }
  }

  function closeAllMenus(menuItems, index) {
    for (let i = 0, l = menuItems.length; i < l; i++) {
      if (index !== i) {
        menuItems[i].classList.remove("menu__item--active");
      }
    }
  }

  function openMenu(event, menuItems, index) {
    if (timer[index]) clearTimeout(timer[index]);

    menuItems[index].classList.add("menu__item--active");
  }

  function closeMenu(event, menuItems, index, delay) {
    if (timer[index]) clearTimeout(timer[index]);

    timer[index] = setTimeout(function () {
      menuItems[index].classList.remove("menu__item--active");
    }, delay);
  }

  function toggleMenu(event, menuItems, index, delay) {
    event.preventDefault();

    closeAllMenus(menuItems, index);

    if (menuItems[index].classList.contains("menu__item--active")) {
      closeMenu(event, menuItems, index, delay);
    } else {
      openMenu(event, menuItems, index);
    }
  }

  return {
    init: init,
  };
})();

bbs.readmore = (function () {
  "use strict";

  function init() {
    var elements = document.querySelectorAll('[data-bbs-module="readmore"]');

    for (let i = 0, l = elements.length; i < l; i++) {
      handleReadMore(elements[i]);
    }
  }

  function handleReadMore(element) {
    var readMoreLink = element.querySelector('[data-readmore="link"]');

    var textTruncated = element.querySelector(
      '[data-readmore="text-truncated"]'
    );
    var textComplete = element.querySelector('[data-readmore="text-complete"]');

    readMoreLink.addEventListener("click", function (event) {
      event.preventDefault();

      requestAnimationFrame(function () {
        textTruncated.style.display = "none";
        textComplete.style.display = "block";
      });
    });
  }

  return {
    init: init,
  };
})();

bbs.viewmore = (function () {
  "use strict";

  function init() {
    var elements = document.querySelectorAll('[data-bbs-module="viewmore"]');

    for (let i = 0, l = elements.length; i < l; i++) {
      handleViewMore(elements[i]);
    }
  }

  function handleViewMore(element) {
    var viewMoreToggle = element.querySelector('[data-bbs-viewmore="toggle"]');
    var viewMoreContent = element.querySelector('[data-bbs-viewmore="content"]');

    viewMoreToggle.addEventListener("click", function (event) {
      event.preventDefault();

      requestAnimationFrame(function () {
        element.classList.toggle("viewmore--more");
        element.classList.toggle("viewmore--less");

        if (viewMoreContent.style.height) {
          viewMoreContent.style.height = null;
        } else {
          viewMoreContent.style.height = viewMoreContent.firstElementChild.offsetHeight + "px";
        }
      });
    });
  }

  return {
    init: init,
  };
})();

bbs.load = (function () {
  "use strict";

  function init() {
    loadModules();
  }

  function loadModules() {
    var modules = [];
    var elements = document.querySelectorAll("[data-bbs-module]");

    for (let i = 0, l = elements.length; i < l; i++) {
      var module = elements[i].getAttribute("data-bbs-module");
      if (modules.indexOf(module) === -1) {
        modules.push(module);
      }
    }

    for (let i = 0, l = modules.length; i < l; i++) {
      if (bbs.hasOwnProperty(modules[i])) {
        bbs[modules[i]].init();
        console.log("Loaded Module: bbs." + modules[i]);
      }
    }
  }

  return {
    init: init,
  };
})();

bbs.geoip = (function () {
  "use strict";

  function getCountryCode() {
    var bbsGeoip = getLocalStorageBbsGeoip();

    if (bbsGeoip !== null) {
      return bbsGeoip.country_code;
    }

    return "";
  }

  function getContinentCode() {
    var bbsGeoip = getLocalStorageBbsGeoip();

    if (bbsGeoip !== null) {
      return bbsGeoip.continent_code;
    }

    return "";
  }

  function getLocalStorageBbsGeoip() {
    if (window.localStorage) {
      var bbsGeoip = window.localStorage.getItem("bbsGeoip");

      if (bbsGeoip !== null) {
        return JSON.parse(bbsGeoip);
      }
    }

    return null;
  }

  function callback(json) {
    if (window.localStorage) {
      if (getLocalStorageBbsGeoip() === null) {
        window.localStorage.setItem("bbsGeoip", JSON.stringify(json));
      }

      document.dispatchEvent(new CustomEvent("BBSGeoipLoaded", { detail: json }));
    }
  }

  return {
    getCountryCode: getCountryCode,
    getContinentCode: getContinentCode,
    callback: callback,
  };
})();

bbs.cartmsg = (function () {
  "use strict";

  var loaded = false;

  function init() {
    if (bbs.geoip.getCountryCode() === "") {
      return;
    }

    var elements = document.querySelectorAll('[data-bbs-module="cartmsg"]');

    for (let i = 0, l = elements.length; i < l; i++) {
      handleCartMsg(elements[i]);
    }

    loaded = true;
  }

  function editTotalCart(totalCart) {
    var elements = document.querySelectorAll('[data-bbs-module="cartmsg"]');

    for (let i = 0, l = elements.length; i < l; i++) {
      var content = elements[i].querySelector('[data-bbs-cartmsg="content"]');

      if (content !== null) {
        content.dataset.bbsCartmsgTotalCart = totalCart
      }

      handleCartMsg(elements[i]);
    }
  }

  function handleCartMsg(element) {
    var content = element.querySelector('[data-bbs-cartmsg="content"]');

    var bbsCartmsgCountry = content.dataset.bbsCartmsgCountry
      .toUpperCase()
      .split(',')
      .map(item => item.trim());

    if (bbsCartmsgCountry.includes(bbs.geoip.getCountryCode()) || bbsCartmsgCountry.includes("ALL")) {
      if (parseFloat(content.dataset.bbsCartmsgTotalCart) >= parseFloat(content.dataset.bbsCartmsgTotalMax)) {
        element.classList.remove("active");

        return;
      }

      if (parseFloat(content.dataset.bbsCartmsgTotalCart) >= parseFloat(content.dataset.bbsCartmsgTotal)) {
        element.classList.add("active");

        return;
      }
    }

    element.classList.remove("active");
  }

  function isloaded() {
    return loaded;
  }

  return {
    init: init,
    editTotalCart: editTotalCart,
    isloaded: isloaded,
  };
})();

bbs.sizeguide = (function () {
  "use strict";

  var loaded = false;

  function init() {
    if (bbs.geoip.getCountryCode() === "") {
      return;
    }

    var elements = document.querySelectorAll('[data-bbs-module="sizeguide"]');

    for (let i = 0, l = elements.length; i < l; i++) {
      handleSizeGuide(elements[i]);
    }

    loaded = true;
  }

  function handleSizeGuide(element) {
    var elements = element.querySelectorAll('[data-change-country]');

    for (let i = 0, l = elements.length; i < l; i++) {
      elements[i].addEventListener("change", function (event) {
        if (elements[i].dataset.changeCountry.includes(event.target.value) === false) {
          return;
        }

        var colspans = elements[i].querySelectorAll('[data-inches="colspan"]');
        var displays = elements[i].querySelectorAll('[data-inches="display"]');

        for (let j = 0, l = colspans.length; j < l; j++) {
          colspans[j].setAttribute("colspan", "1");
        }

        for (let j = 0, l = displays.length; j < l; j++) {
          displays[j].style.display = "none";
        }

        if (['US', 'GB', 'CA'].includes(event.target.value)) {
          for (let j = 0, l = colspans.length; j < l; j++) {
            colspans[j].setAttribute("colspan", "2");
          }

          for (let j = 0, l = displays.length; j < l; j++) {
            displays[j].style.display = "block";
          }
        }

        var countries = elements[i].querySelectorAll('div[data-country]');

        for (let j = 0, l = countries.length; j < l; j++) {
          countries[j].style.display = "none";
        }

        var countries = elements[i].querySelectorAll('div[data-country="' + event.target.value + '"]');

        for (let j = 0, l = countries.length; j < l; j++) {
          countries[j].style.display = "block";
        }
      });

      var selects = elements[i].querySelectorAll('select[name=\'country\']');

      for (let j = 0, l = selects.length; j < l; j++) {
        selects[j].value = bbs.geoip.getCountryCode();
        selects[j].dispatchEvent(new Event('change'));
      }
    }
  }

  function isloaded() {
    return loaded;
  }

  return {
    init: init,
    isloaded: isloaded,
  };
})();

bbs.tool = (function () {
  "use strict";

  function loadScript(src, async = false) {
    let script = document.createElement("script");
    script.src = src;
    script.async = async;
    document.body.append(script);
  }

  return {
    loadScript: loadScript,
  };
})();

document.addEventListener("DOMContentLoaded", function () {
  bbs.load.init();
});

document.addEventListener("BBSGeoipLoaded", function (event) {
  if (bbs.cartmsg.isloaded() === false) {
    bbs.cartmsg.init();
  }

  if (bbs.sizeguide.isloaded() === false) {
    bbs.sizeguide.init();
  }

  document.addEventListener("BBSCartUpdated", function (event) {
    var total = theme.Currency.formatMoney(event.detail.total_price, '{{amount}}');
    bbs.cartmsg.editTotalCart(total);
  });

  document.addEventListener("shopify:section:load", function (event) {
    if (event.detail.sectionId === "cart-template") {
      bbs.cartmsg.init();
    }
  });
});

